import { z } from 'zod';

export const FormSchema = z.object({
  company: z.string().nonempty(),
  tax_allocation: z.boolean(),
  tax_code: z.string().nonempty(),
  authorized_tax_finalization: z.boolean(),
  company_name: z.string().nonempty(),
  address: z.string().nonempty(),
  contact_person: z.string().nonempty(),
  signer: z.string().nonempty(),
  mail: z.string().nonempty(),
  phone: z.string().nonempty(),
  city: z.string().nonempty(),
  district: z.string().nonempty(),
  ward: z.string().nonempty(),
  fax: z.string().nonempty(),
  industry: z.string().nonempty(),
  status: z.string().nonempty()
});
export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  company: 'all',
  tax_allocation: false,
  tax_code: '',
  authorized_tax_finalization: false,
  company_name: '',
  address: '',
  contact_person: '',
  signer: '',
  mail: '',
  phone: '',
  city: '',
  district: '',
  ward: '',
  fax: '',
  industry: '1',
  status: '1'
};
